import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import { connect, useDispatch, useSelector } from "react-redux";
import { addSurgePricing, addTransation, getAllSurgePricing, getAllTransation, updateSurgePricing, updateTransationCharges } from "../../redux/action/additionalprice";
import { Formik } from "formik";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import NoImage from "../../assets/images/noimages.jpg";
import { APIURL } from "../../redux/action/config";
import { TransationCharges, Pricing } from "../../utills/Validation";
import { updateFleet } from "../../redux/action/fleet";
const initialState = { alt: "", src: "" };

const AddTransitionCharges = () => {
  const dispatch = useDispatch();
  const [img, setImg] = useState();
  const transaction = useSelector((state) => state.additionalprice.list?.[0]);
  const transactionList = useSelector((state) => state.additionalprice.list);
  const surgeData = useSelector((state) => state.additionalprice.surgeList?.[0]);
  const surgeList = useSelector((state) => state.additionalprice.surgeList);
  const resetForms = () => {
    document.getElementById("myForm").reset();
  };
  useEffect(()=>{
    dispatch(getAllTransation())
    dispatch(getAllSurgePricing())
  },[])

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Additional Prices" page="charges">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row mt-5">
              <div className="col-xl-6 mt-5">
                <div className="card card-flush h-lg-100 mt-5">
                    <div className="card-header pt-7 mt-5">
                      <div className="card-title">
                        <span className="svg-icon svg-icon-1 me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                              fill="black"
                            ></path>
                            <path
                              opacity="0.3"
                              d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <h2>Add Transaction Charges</h2>
                      </div>
                    </div>
                      <div className="card-body pt-5">
                        <Formik
                          initialValues={{
                            transaction: transaction?.charges,
                          }}
                          // validationSchema={TransationCharges}
                          onSubmit={(values, { setSubmitting, resetForm }) => {
                            if(transactionList?.length){
                              dispatch(updateTransationCharges(values, transaction?.id));
                            } else {
                              dispatch(addTransation(values));
                            }
                            // dispatch(addTransation(values));
                            // resetForm({ values: "" });
                            // resetForms();
                            setSubmitting(false);
                          }}
                        >
                          {({
                            values,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            errors,
                            touched,
                          }) => (
                            <form
                              className="form"
                              onSubmit={handleSubmit}
                              id="myForm1"
                            >
                              <div className="row row-cols-1">
                                  <div className="col-12">
                                      <div className="fv-row mb-7 fv-plugins-icon-container">
                                          <label className="fs-6 fw-bold form-label mt-3">
                                              <span className="required">Transaction Charges (%)</span>
                                          </label>
                                          <input
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              name="transaction"
                                              id="transaction"
                                              defaultValue={values.transaction ? values.transaction : transaction?.charges}
                                              placeholder="Enter Transaction Charges"
                                              className="form-control form-control-solid"
                                          />
                                          {errors.transaction && touched.transaction ? (
                                              <div className="text-danger mt-2">
                                                  {errors.transaction}
                                              </div>
                                          ) : null}
                                      </div>
                                  </div>
                              </div>
                              <div className="separator mb-6"></div>
                              <div className="d-flex justify-content-end">
                                <Link
                                  to="/manage-fleet"
                                  type="reset"
                                  className="btn btn-light me-3"
                                >
                                  Cancel
                                </Link>
                                <button type="submit" className="btn btn-primary">
                                  <span className="indicator-label">{transactionList?.length ? 'Update' : 'Save'}</span>
                                </button>
                              </div>
                              <div></div>
                            </form>
                          )}
                        </Formik>
                      </div>
                  </div>
              </div>
              <div className="col-xl-6 mt-5">
                <div className="card card-flush h-lg-100 mt-5">
                    <div className="card-header pt-7 mt-5">
                      <div className="card-title">
                        <span className="svg-icon svg-icon-1 me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                              fill="black"
                            ></path>
                            <path
                              opacity="0.3"
                              d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <h2>Define Surge Pricing</h2>
                      </div>
                    </div>
                    <div className="card-body pt-5">
                      <Formik
                        initialValues={{
                          surge: surgeData?.price,
                          startTime: surgeData?.startTime,
                          endTime: surgeData?.endTime,
                        }}
                        // validationSchema={Pricing}
                        onSubmit={(values) => {
                          if(surgeList?.length){
                            dispatch(updateSurgePricing(values, surgeData?.id));
                          } else {
                            dispatch(addSurgePricing(values));
                          }
                          // resetForm({ values: "" });
                          // resetForms();
                          // setSubmitting(false);
                        }}
                      >
                        {({
                          values,
                          handleBlur,
                          handleChange,
                          handleSubmit,
                          errors,
                          touched,
                        }) => (
                          <form
                            className="form"
                            onSubmit={handleSubmit}
                            id="myForm"
                          >
                            <div className="row row-cols-1">
                              <div className="col-12">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <label className="fs-6 fw-bold form-label mt-3">
                                    <span className="required">Surge Price($)</span>
                                  </label>
                                  <input
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="surge"
                                    id="surge"
                                    defaultValue={surgeData.price ? surgeData.price : values.surge}
                                    className="form-control form-control-solid"
                                    placeholder="Enter Surge Price"
                                  />
                                  {errors.surge && touched.surge ? (
                                    <div className="text-danger mt-2">
                                      {errors.surge}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-6">
                                  <div className="fv-row mb-7 fv-plugins-icon-container">
                                    <label className="fs-6 fw-bold form-label mt-3">
                                      <span className="required">Start Time</span>
                                    </label>
                                    <input
                                      type="time"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="startTime"
                                      id="startTime"
                                      defaultValue={surgeData.startTime ? surgeData.startTime : values.startTime}
                                      className="form-control form-control-solid custom-time-input"
                                    />
                                    {errors.startTime && touched.startTime ? (
                                      <div className="text-danger mt-2">
                                        {errors.startTime}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                                <div className="col-6">
                                  <div className="fv-row mb-7 fv-plugins-icon-container">
                                    <label className="fs-6 fw-bold form-label mt-3">
                                      <span className="required">End Time</span>
                                    </label>
                                    <input
                                      type="time"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="endTime"
                                      id="endTime"
                                      defaultValue={surgeData.endTime ? surgeData.endTime : values.endTime}
                                      className="form-control form-control-solid custom-time-input"
                                    />
                                    {errors.endTime && touched.endTime ? (
                                      <div className="text-danger mt-2">
                                        {errors.endTime}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="separator mb-6"></div>
                            <div className="d-flex justify-content-end">
                              <Link
                                to="/manage-fleet"
                                type="reset"
                                className="btn btn-light me-3"
                              >
                                Cancel
                              </Link>
                              <button type="submit" className="btn btn-primary">
                                <span className="indicator-label">{surgeList?.length ? 'Update' : 'Save'}</span>
                              </button>
                            </div>
                            <div></div>
                          </form>
                        )}
                      </Formik>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default connect(null, { addTransation })(AddTransitionCharges);
